module.exports = __webpack_public_path__ + "media/images/icon/profit-b594f0b7df25fa4f823d60244665cc04.svg";